import { notify } from "../../event-bus";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    message: {}
  },
  getters: {
    message: (state) => {
      return state.message;
    },
  },
  actions: {
    sendMessage({ commit }, payload) {
      return Vue.http
        .post(`${process.env.VUE_APP_BACKEND_APP}/api/messages`, payload, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then(() => {
          commit("messageData", payload);
          notify("MESSAGGIO INVIATO CORRETTAMENTE", "SUCCESS");
        })
        .catch((error) => {
          notify(error, "ERROR");
        });
    },
  },
  mutations: {
    messageData(state, message) {
      state.message = message;
    },
  },
};
